import { voiceCampaignsRoutes } from "./campaigns";
import { CompanyWalletRoutes } from "./CompanyWallet/CompanyWallet.router";
import { paymentsRoutes } from "./payments";
import { externalLeadsRoutes } from "./ExternalLeads";

export const appViewsRoutes = [...CompanyWalletRoutes]
.concat(voiceCampaignsRoutes)
.concat(paymentsRoutes)
.concat(externalLeadsRoutes);

